import { useEffect, useRef } from "react";
import "../styles/style.css";

export default function CodeBackground() {
    const containerRef = useRef(null);
    const typingIntervals = useRef([]);

    useEffect(() => {
        const snippets = [
            'console.log("Hi, Mohamed Eltohamy!")',
            'let name="Mohamed Eltohamy";',
            "let visitors = 0;",
            "function greet(){ return name; }",
            'const skills = ["HTML","CSS","JS","React"];',
            "skills.forEach(s => console.log(s));",
            'setTimeout(() => console.log("Done"), 1000);',
            'document.body.style.background = "#18aaff";',
            "let c = 0; while(c < 10) c++;",
            'const info = { n: "Mohamed", r: "Front-end" };',
            'fetch("/api").then(r => r.json()).then(d => console.log(d));'
        ];

        const container = containerRef.current;

        if (!container) return;

        const positions = [];
        const maxVisible = 25;
        const minDistance = 15;

        function getPosition() {
            let attempts = 0;

            while (attempts < 100) {
                const top = 5 + Math.random() * 85;
                const left = 5 + Math.random() * 80;

                let valid = true;

                for (const p of positions) {
                    if (Math.hypot(p.top - top, p.left - left) < minDistance) {
                        valid = false;
                        break;
                    }
                }

                if (valid) {
                    positions.push({ top, left });
                    return { top, left };
                }

                attempts++;
            }

            const pos = {
                top: 5 + Math.random() * 85,
                left: 5 + Math.random() * 80,
            };

            positions.push(pos);

            return pos;
        }

        function createLine(text) {
            const line = document.createElement("p");
            line.className = "code-line";

            const { top, left } = getPosition();

            line.style.top = `${top}%`;
            line.style.left = `${left}%`;

            const fragment = document.createDocumentFragment();
            fragment.appendChild(line);

            requestAnimationFrame(() => {
                container.appendChild(fragment);
            });

            let i = 0;

            const typing = setInterval(() => {
                line.textContent = text.slice(0, i + 1);

                i++;

                if (i >= text.length) {
                    clearInterval(typing);
                }
            }, 60);

            typingIntervals.current.push(typing);
        }

        let count = 0;

        const interval = setInterval(() => {
            if (count >= maxVisible) {
                clearInterval(interval);
                return;
            }

            createLine(
                snippets[Math.floor(Math.random() * snippets.length)]
            );

            count++;
        }, 1200);

        return () => {
            clearInterval(interval);

            typingIntervals.current.forEach(clearInterval);
            typingIntervals.current = [];

            container.innerHTML = "";
        };
    }, []);

    return <div ref={containerRef} className="code-background"></div>;
}